<template>
  <div id="hcpSearchView">
    <div class="content">
      <div class="filter">
        <span>Showing results from</span>
        <mu-select-field v-model="filterType">
          <mu-menu-item value="education" title="Education" />
          <mu-menu-item value="resources" title="Resources" />
        </mu-select-field>
      </div>
      <mu-card>
        <mu-card-title :title='`Results for: "${$route.params.search}"`' />
        <mu-card-text>
          <p v-if="!hasResults">Could not find any results based on your search</p>
          <mu-list>
            <div class="item" v-for="item, index in results" :key="`item-${index}`" v-if="!isLoading">
              <mu-list-item :title="item.title" @click.native="linkSearchItem(item.type, item.link)">
                <div slot="left" class="icon">
                  <mu-icon :value="getSearchType(item.type).icon " />
                </div>
                <div class="mu-item-text" v-html="$sanitize(highlightKeyword(item.desc, [$route.params.search, $route.params.search + 's']))"></div>
              </mu-list-item>
              <mu-divider :inset="true" v-if="(index+1) !== results.length" />
            </div>
            <mu-list-item v-for="item, index in 10" :key="`item-${index}`" v-if="isLoading">
              <div slot="describe">
                <mu-linear-progress
                  color="#d9d9d9"
                  style="height:15px; width: 15%; background: #f1f1f1; margin: 0 0 16px;"
                ></mu-linear-progress>
              </div>
              <mu-linear-progress
                color="#d9d9d9"
                style="height:20px; width: 50%; background: #f1f1f1"
              ></mu-linear-progress>
            </mu-list-item>
          </mu-list>
        </mu-card-text>
      </mu-card>
    </div>
  </div>
</template>

<script type="text/javascript">
  import HcpApi from '../../../api/Hcp'
  import TitleManager from '../../../helpers/TitleManager'

  export default {
    watch: {
      "filterType": function() {
        let self = this;
        let type = self.filterType;
        self.$router.replace({
          query: {
            type: type
          }
        });
        self.doSearch();
      }
    },
    data() {
      return {
        filterType: 'education',
        isLoading: true,
        results: []
      }
    },
    methods: {
      doSearch() {
        let self = this;
        self.results = [];
        HcpApi.searchHcp(self.$route.params.search, self.filterType).then(response => {
          TitleManager.setTitle(self.$route.params.search);
          self.results = response.data;
          self.isLoading = false;
        });
      },
      highlightKeyword(input, wordsToBold) {
        return input.replace(new RegExp('(\\b)(' + wordsToBold.join('|') + ')(\\b)','ig'), '$1<b>$2</b>$3');
      },
      initMounted() {
        let self = this;
        self.isLoading = true;
        self.results = [{}];
        TitleManager.setTitle(self.$t('message.loadingText'));
        window.document.title = self.$route.params.search + ' | Low Carb Program';
        self.doSearch();
      },
      getSearchType(type) {
        let icon = null;
        if (type === 'resource') {
          icon = 'file_download';
        }
        if (type === 'education') {
          icon = 'local_florist';
        }
        return {
          icon : icon
        }
      },
      linkSearchItem(type, link) {
        let self = this;
        if (type === 'resource') {
          window.open(link, '_blank');
        }
        if (type === 'education') {
          self.$router.push({
            name: 'HcpArticle',
            params: {
              slug: link
            }
          })
        }
      }
    },
    mounted() {
      let self = this;
      self.filterType = self.$route.query.type || 'education';
      self.initMounted();
    },
    computed: {
      hasResults() {
        let self = this;
        return self.results.length > 0;
      }
    }
  }
</script>

<style lang="less">
  @import "../../../styles/theme.less";
  #hcpSearchView {
    .filter {
      margin: -5px 0 8px;
      > span {
        display: inline-block;
        margin: 0 2px 0 0;
        font-size: 15px;
        color: fade(#000, 60%);
        position: relative;
        top: -11px;
      }
      .mu-text-field {
        margin: 0;
      }
      .mu-dropDown-menu-text-overflow {
        color: @primaryColor;
      }
    }
    .mu-card-title-container {
      padding: 24px;
      padding-bottom: 0;
      .mu-card-title {
        font-weight: 500;
      }
    }
    .mu-card-text {
      padding: 24px;
      padding-top: 16px;
      font-size: 15px;
    }
    .item {
      .icon {
        .mu-icon {
          color: @primaryColor;
          position: relative;
          top: 5px;
        }
      }
      .mu-item-title {
        line-height: 27px;
        margin: 8px 0;
        font-size: 18px;
        font-weight: 500;
        color: @primaryColor;
      }
      .mu-item-text {
        margin: 8px 0;
        max-height: 56px!important;
        width: 50%;
        line-height: 1.6;
        font-size: 16px;
        color: fade(#000, 60%)!important;
        word-break: break-word;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Search.vue?965113ca